const API_URL = "https://login-app.khurat.com";

const availableScreens = [".login-box", ".verify-box", ".update-user-box"];
const formData_Otp = {};
let loginWith = 0;
const defaultFieldObj = {
  value: "",
  rules: "required | regex:^[0-9]+$ | min: 10 | max: 10",
  name: "first name",
  error: "",
  selector: "",
};

function toggleLogin(type = 0) {
  loginWith = type;
  switch (type) {
    case 0:
      document.getElementById("login_phone").classList.remove("hideBox");
      document.getElementById("login_email").classList.add("hideBox");
      document.getElementById("loginToggleBtn0").classList.add("hideBox");
      // document.getElementById("loginToggleBtn2").classList.remove("hideBox");
      document.getElementById("loginToggleBtn1").classList.remove("hideBox");
      setFormData({
        name: "mobile",
        selector: "mobile-no-inp",
        realtimeError: false,
      });
      document.getElementById("phone_input")?.focus();
      unsetFormData("email");
      // unsetFormData('whatsapp');
      break;
    case 1:
      document.getElementById("login_phone").classList.add("hideBox");
      document.getElementById("login_email").classList.remove("hideBox");
      document.getElementById("loginToggleBtn0").classList.remove("hideBox");
      // document.getElementById("loginToggleBtn2").classList.remove("hideBox");
      document.getElementById("loginToggleBtn1").classList.add("hideBox");
      setFormData({
        name: "email",
        selector: "email-no-inp",
        rules:
          "required | regex: \\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+",
        realtimeError: false,
      });
      document.getElementById("email_input")?.focus();
      unsetFormData("mobile");
    // unsetFormData('whatsapp');
    default:
      break;
  }
}

function apiReq({ method, redirect, endpoint, data }) {
  return new Promise((resolve, reject) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: method,
        headers: myHeaders,
        body: JSON.stringify(data),
      };
      fetch(`${API_URL}${endpoint}`, requestOptions)
        .then(async (response) => ({
          data: await response.json(),
          res: response,
        }))
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    } catch (error) {
      reject(error);
    }
  });
}

function setFormData(field) {
  const { name } = field;
  if (!formData_Otp[name]) {
    formData_Otp[name] = {
      ...defaultFieldObj,
      ...field,
    };
  }
}

function unsetFormData(fieldName) {
  delete formData_Otp[fieldName];
}
function handleEnter(e) {
  var divElement = document.getElementById("spinner-prevent");
  // Check if the class 'custom-spinner-wrapper' is added to the div
  if (!divElement) return;
  if (
    divElement.classList.contains("custom-spinner-wrapper") &&
    divElement.classList.contains("hideBox") && 
     e.key === "Enter"
  ) {
      sendOtp();
  }
}
function onInput(e, field) {;
  const { name, labelSelector } = field;

  if (!formData_Otp[name]) {
    return; //"NO SUCH FIELD AVAILABLE"
  }

  formData_Otp[name].value = e.target.value;

  const { value, rules, realtimeError = true } = formData_Otp[name];
  if (labelSelector) {
    if (value) {
      document.querySelector(labelSelector)?.classList.add("is-filled");
    } else {
      document.querySelector(labelSelector)?.classList.remove("is-filled");
    }
  }
  if (realtimeError) {
    checkErrors({
      field: formData_Otp[name],
      validations: rules,
      event: e,
      name,
    });
  }
}

// Function to update the timer display
function updateTimer(time) {
  let timeLeft = time;
  let minutes = Math.floor(timeLeft / 60);
  let seconds = timeLeft % 60;

  // Add leading zero if seconds less than 10
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  // Update the timer display
  document.getElementById("timer").innerHTML = minutes + ":" + seconds;
}
let countdown;
// Function to start the countdown
function startTimer() {
  let element = document.getElementById("timer");
  let timeLeft = 60;
  element.classList.remove("hideBox");
  // Update the timer display initially
  updateTimer(timeLeft);
  document.querySelector(".resend-btn")?.classList.add("disabled");

if (countdown) clearInterval(countdown);
  countdown = setInterval(function () {
    timeLeft--; // Decrease time left by 1 second
    updateTimer(timeLeft); // Update the timer display

    // If timer reaches 0, stop the countdown
    if (timeLeft <= 0) {
      resetTimer();
    }
  }, 1000); // Update every second (1000 milliseconds)
}

function resetTimer() {
  if (countdown) clearInterval(countdown);
    let element = document.getElementById("timer");
    if (element) {
      element.innerHTML = ""; // Display 0:00 when time's up
      element.classList.add("hideBox");
      document.querySelector(".resend-btn")?.classList.remove("disabled");
    }
}


function updateWidgetMinHeight() {
 const header = document.querySelector('sticky-header');
  const footer = document.querySelector('.shopify-section-group-footer-group');
  const widget = document.querySelector('.sotp-widget');

  if (header && footer && widget) {
    const headerHeight = header.offsetHeight || 0;
    const footerHeight = footer.offsetHeight || 0;
    const totalHeight = headerHeight + footerHeight;

    widget.style.minHeight = `calc(100vh - ${totalHeight}px)`; // ✅ Correct order
  }
}

document.addEventListener('DOMContentLoaded', updateWidgetMinHeight);
window.addEventListener('resize', updateWidgetMinHeight);
function sendOtp() {
  updateWidgetMinHeight();
  let field = {};
  let key = "";
  let axiosObj = {};
  let inputEl = null;

  if (loginWith === 0) {
    key = "mobile";
    inputEl = document.getElementById("phone_input");
    //field = { mobile: formData_Otp["mobile"] };
    // axiosObj = {
    //   isEmail: false,
    //   phoneNumber: formData_Otp[key].value,
    // };
  } else if (loginWith === 1) {
    key = "email";
    inputEl = document.getElementById("email_input");
    //field = { email: formData_Otp["email"] };
    // axiosObj = {
    //   isEmail: true,
    //   email: formData_Otp[key].value,
    // };
  }

   // 🔐 HARD GUARDS
 if (!key || !inputEl || !inputEl.value) {
    return;
  }
  const value = inputEl.value.trim();

   // 🔥 FORCE SYNC (CRITICAL)
  if (!formData_Otp[key]) {
    setFormData({
      name: key,
      selector: key === "mobile" ? "mobile-no-inp" : "email-no-inp",
      realtimeError: false,
    });
  }

  // 🔐 ALWAYS TRUST DOM ON CLICK
  formData_Otp[key].value = value;

   // build request only AFTER validation
  axiosObj =
    key === "mobile"
      ? { isEmail: false, phoneNumber: formData_Otp[key].value }
      : { isEmail: true, email: formData_Otp[key].value };

  // validate AFTER sync
  field = { [key]: formData_Otp[key] };
  


  checkAllFields(field)
    .then((valid) => {
      if (valid) {
        toggleSpinner(true);
        document.querySelector(".send-btn")?.classList.add("pointer-events-btn");
        apiReq({ method: "POST", endpoint: "/api/v2/sendOtp", data: axiosObj })
          .then(({ res, data }) => {
            if (res.status === 200) {
              setFormData({
                name: "verifyOtp",
                selector: "verifyOtp-inp",
                rules: "required | min: 6 | regex: ^[0-9]+$",
                realtimeError: false,
              });

              document
                .querySelector(availableScreens[0])
                .classList.add("hideBox");
              document
                .querySelector(availableScreens[1])
                .classList.remove("hideBox");

              setTimeout(() => {
                document.querySelector(".user-details").innerHTML =
                  key == "mobile"
                    ? `+91 ${formData_Otp[key].value}`
                    : `${formData_Otp[key].value}`;
                document.querySelector("#verifyType").innerHTML =
                  key == "mobile" ? "Phone" : "Email";
              });
            } else {
              if (res.status === 400) {
                document.querySelector(`.${formData_Otp[key].selector}`).innerText =
                  data.message;
                setTimeout(() => {
                  document.querySelector(
                    `.${formData_Otp[key].selector}`
                  ).innerText = "";
                }, 6000);
              } else {
                console.error("ERROR", res.status, data);
              }
            }
            // document.querySelector(".resend-btn").classList.add('disabled');
            startTimer();
            document.querySelector(".send-btn")?.classList.remove("pointer-events-btn");
            toggleSpinner(false);
            const inputElement = document.getElementById(
              "otp-input-main-focus"
            );
            if (inputElement) {
              inputElement.focus();
            }
          })
          .catch((error) => {
            toggleSpinner(false);
            console.error("ERROR in api: ", error);
            document.querySelector(".send-btn")?.classList.remove("pointer-events-btn");
          });
      }
    })
    .catch((error) => {
      console.error("ERROR: ", error);
    });
}

let isVerifyingOtp = false;
function verifyOtp() {
  if (isVerifyingOtp) return;
  isVerifyingOtp = true;
  let field = {};
  let key = "";
  let axiosObj = {};
  if (loginWith === 0) {
    key = "mobile";
    field = { mobile: formData_Otp["mobile"] };
    axiosObj = {
      isEmail: false,
      phoneNumber: formData_Otp[key].value,
    };
  } else if (loginWith === 1) {
    key = "email";
    field = { email: formData_Otp["email"] };
    axiosObj = {
      isEmail: true,
      email: formData_Otp[key].value,
    };
  }
  checkAllFields(formData_Otp)
    .then((valid) => {
      if (valid) {
        toggleSpinner(true);
        // document
        //   .querySelector(".verify-btn")
        //   .classList.add("pointer-events-btn");
        apiReq({
          method: "POST",
          endpoint: "/api/v2/verifyOtp",
          data: { ...axiosObj, otp: Number(formData_Otp["verifyOtp"].value) },
        })
          .then(({ res, data }) => {
            if (res.status === 202) {
              unsetFormData("verifyOtp");

              document
                .querySelector(availableScreens[1])
                .classList.add("hideBox");

              // IF NEW USER
              document
                .querySelector(availableScreens[2])
                .classList.remove("hideBox");
              setFormData({
                name: "firstName",
                selector: "firstName-inp",
                rules: "required",
                realtimeError: false,
              });
              setFormData({
                name: "lastName",
                selector: "lastName-inp",
                rules: "required",
                realtimeError: false,
              });
              if (loginWith !== 1) {
                setFormData({
                  name: "email",
                  selector: "email-inp",
                  rules:
                    "required | regex: \\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+",
                  realtimeError: false,
                });
                // setFormData({name: 'phoneNumber', selector: 'phoneNumber-inp', rules: "required", realtimeError: false})

                setTimeout(() => {
                  document.querySelector(".user-data-phone-number").value =
                    formData_Otp[key].value;
                  document.querySelector(
                    ".user-data-phone-number"
                  ).disabled = true;
                  document
                    .querySelector(".input-box-content.mobile-no-inner")
                    .classList.add("disabled-phone-num");
                  document
                    .querySelector(".user-data-phone-number")
                    .classList.add("is-filled");
                });
              } else {
                setFormData({
                  name: "phoneNumber",
                  selector: "phoneNumber-inp",
                  rules: "required",
                  realtimeError: false,
                });
                setTimeout(() => {
                  document.querySelector(".update-user-email-input").value =
                    formData_Otp[key].value;
                  document.querySelector(
                    ".update-user-email-input"
                  ).disabled = true;
                  document
                    .querySelector(".input-box-content.email-inp-wrapper")
                    .classList.add("disabled-phone-num");
                  document
                    .querySelector(".update-user-email-input")
                    .classList.add("is-filled");
                });
              }
              toggleSpinner(false);
            } else if (res.status === 200) {
              shopifyVerify({
                email: data.email,
                password: data.password,
              });
            } else {
              toggleSpinner(false);
              if (res.status === 400) {
                document.querySelector(
                  `.${formData_Otp["verifyOtp"].selector}`
                ).innerText = data.message;
                setTimeout(() => {
                  document.querySelector(
                    `.${formData_Otp["verifyOtp"].selector}`
                  ).innerText = "";
                }, 6000);
              } else {
                console.error("ERROR", res.status, data);
              }
            }
            // document
            //   .querySelector(".verify-btn")
            //   .classList.remove("pointer-events-btn");
            isVerifyingOtp = false;
          })
          .catch((error) => {
            toggleSpinner(false);
            console.error("ERROR in api: ", error);
            // document
            //   .querySelector(".verify-btn")
            //   .classList.remove("pointer-events-btn");
            isVerifyingOtp = false;
          });
      }
    })
    .catch((error) => {
      isVerifyingOtp = false;
      console.error("ERROR: ", error);
    });
}

function sendUserData() {
  checkAllFields(formData_Otp)
    .then((valid) => {
      if (valid) {
        toggleSpinner(true);
        let userDetail = {
          firstName: formData_Otp["firstName"].value,
          lastName: formData_Otp["lastName"].value,
          email: formData_Otp[loginWith === 1 ? "email" : "email"].value,
          phoneNumber:
            formData_Otp[loginWith !== 1 ? "mobile" : "phoneNumber"].value,
          // "keepUpdated":document.querySelector(".keep-updated").checked
        };
        document
          .querySelector(".update-btn")
          .classList.add("pointer-events-btn");
        apiReq({
          method: "POST",
          endpoint: "/api/v1/createUser",
          data: userDetail,
        })
          .then(({ res, data }) => {
            if (res.status === 200) {
              shopifyVerify({
                email: data.email,
                password: data.passWord,
              });
              unsetFormData("mobile");

              document
                .querySelector(availableScreens[2])
                .classList.add("hideBox");
              // IF NEW USER DATA SENT
              unsetFormData("firstName");
              unsetFormData("lastName");
              unsetFormData("email");
              unsetFormData("phoneNumber");
            } else {
              if (data.message.includes("422")) {
                if (loginWith !== 1) {
                  document.querySelector(".email-inp").innerHTML =
                    "Email already exists";
                  setTimeout(() => {
                    document.querySelector(".email-inp").innerHTML = "";
                  }, 6000);
                } else {
                  document.querySelector(".phoneNumber-inp").innerHTML =
                    "Phone number already exists";
                  setTimeout(() => {
                    document.querySelector(".phoneNumber-inp").innerHTML = "";
                  }, 6000);
                }
              } else {
                console.error("ERROR", res.status, data);
              }
              toggleSpinner(false);
            }
            document
              .querySelector(".update-btn")
              .classList.remove("pointer-events-btn");
          })
          .catch((error) => {
            console.error("ERROR in api: ", error);
            toggleSpinner(false);
            document
              .querySelector(".update-btn")
              .classList.remove("pointer-events-btn");
          });
      }
    })
    .catch((error) => {
      console.error("ERROR: ", error);
    });
}

function shopifyVerify(data) {
  const {
    email,
    password,
    return_url = "/account",
    url = "https://khurat.com/account/login",
  } = data;
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  const urlencoded = new URLSearchParams();
  urlencoded.append("form_type", "customer_login");
  urlencoded.append("customer[email]", email);
  urlencoded.append("customer[password]", password);
  urlencoded.append("return_url", return_url);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    // redirect: redirect
  };

  fetch(url, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      toggleSpinner(false);
      let par = new URLSearchParams(window.location.search);
      let checkOut = par.get("checkout_url");
      window.location.href = checkOut
        ? `https://khurat.com${checkOut}`
        : "https://khurat.com";
    })
    .catch((error) => {
      toggleSpinner(false);
      console.error(error);
    });
}
function editNumber() {
  document.querySelector(availableScreens[1]).classList.add("hideBox");
  document.querySelector(availableScreens[0]).classList.remove("hideBox");
  document.querySelector(".error.verifyOtp-inp").innerHTML = "";
  document.querySelector(".otp-input-main").value = "";

  unsetFormData("verifyOtp");
}
function toggleSpinner(showSpinner) {
  document
    .querySelector(".custom-spinner-wrapper")
    .classList[!showSpinner ? "add" : "remove"]("hideBox");
}


let otpInputVal = document.getElementById("otp-input-main-focus");
if (otpInputVal) {
  otpInputVal.addEventListener("input", function () {
    if (this.value.length === 6) {
      formData_Otp["verifyOtp"].value = this.value;
      verifyOtp();
    }
  });
  // Periodically check for autofill
  setInterval(() => {
    if (otpInputVal.value.length === 6 && formData_Otp["verifyOtp"].value !== otpInputVal.value) {
      formData_Otp["verifyOtp"].value = otpInputVal.value;
      verifyOtp();
    }
  }, 500);
}
// function checkVerifyOtp(params) {
//   const value = params?.target?.value || "";
//   const isSpinnerVisible = document.querySelector(
//     ".custom-spinner-wrapper.hideBox"
//   );

//   if (
//     value.length === 6 &&
//     isSpinnerVisible &&
//     (params.key === undefined || !isNaN(params.key))
//   ) {
//     verifyOtp();
//   }
// }

function checkVerifyOtp(params) {
  const value = params?.target?.value || document.getElementById("otp-input-main-focus")?.value || "";
  const isSpinnerVisible = document.querySelector(".custom-spinner-wrapper.hideBox");
  if (value.length === 6 && isSpinnerVisible) {
    formData_Otp["verifyOtp"].value = value;
    verifyOtp();
  }
}


// const toggleBtn = document.querySelector('.toggle-btn');
const phoneInput = document.getElementById('phone_input');
//const emailInput = document.getElementById('email_input');
//const sendBtn = document.querySelector('.send-btn');

if (phoneInput) {
  // Phone input: allow only digits on keypress
  phoneInput.addEventListener('keypress', function (e) {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  });

  // Phone input: prevent pasting non-numeric content
  phoneInput.addEventListener('paste', function (e) {
    const pastedData = (e.clipboardData || window.clipboardData).getData('text');
    if (!/^\d+$/.test(pastedData)) {
      e.preventDefault();
    }
  });

  // Sanitize and update for phone
  function sanitizePhoneInput() {
    phoneInput.value = phoneInput.value.replace(/\D/g, '');
    // updateSendBtnState();
  }

  // Listen to input/change events
  phoneInput.addEventListener('input', sanitizePhoneInput);
  phoneInput.addEventListener('change', sanitizePhoneInput);
}


let otpInputValssss = document.getElementById("otp-input-main-focus");
// let verifyBtn = document.querySelector('.verify-btn');
if(otpInputValssss){
  function allowOnlyDigits(event) {
    // Keep only digits
    otpInputValssss.value = otpInputValssss.value.replace(/\D/g, '');
  }

  otpInputValssss.addEventListener('input', allowOnlyDigits);
  otpInputValssss.addEventListener('change', allowOnlyDigits);

  // Optional: Block non-digit key presses
  otpInputValssss.addEventListener('keypress', function (e) {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  });

  // Optional: Block non-digit paste
  otpInputValssss.addEventListener('paste', function (e) {
    const pastedData = (e.clipboardData || window.clipboardData).getData('text');
    if (!/^\d+$/.test(pastedData)) {
      e.preventDefault();
    }
  });
}
$(document).on('click', '#loginToggleBtn1', function() {
  $('#phone_input').val('');
});
$(document).on('click', '#loginToggleBtn0', function() {
  $('#email_input').val('');
});
window.onInput = onInput;
window.handleEnter = handleEnter;